var SCM = SCM || {};

(function (ns, $) {

    var accessTooltipSequence = 0;
    var EDGE_THRESHOLD_PIXELS = 10;
    var NON_VISIBLE_OVERFLOW = /(auto|scroll|hidden|clip)/;
    var documentClickDismissHandler = null;
    var documentKeydownDismissHandler = null;

    var supportsFocusVisible = (function () {
        try {
            document.querySelector(':focus-visible');
            return true;
        } catch (error) {
            return false;
        }
    })();

    ns.setAccessIcons = function (accessIcons) {
        accessIcons = accessIcons || SCM.AccessIcons;

        var currentResourceList = $('[data-resource-id-access]');
        if (currentResourceList.length && accessIcons) {
            currentResourceList.each(function (index, item) {
                var $this = $(this);
                var resourceId = $this.data('resourceIdAccess');

                var accessIcon = SCM.SiteJS.getAccessIcon(resourceId, accessIcons);
                if (accessIcon) {
                    var $placeholder = $this.find('.js-access-icon-placeholder');

                    if ($placeholder.length === 0) {
                        return;
                    }

                    unwrapAccessTooltip($placeholder);

                    // replace icon css class
                    removeAllAccessIconClasses($placeholder);
                    $placeholder.removeClass(accessIcon.icon).addClass(accessIcon.icon);

                    // replace icon title
                    $placeholder.attr('title', accessIcon.title);

                    // add screenreader text
                    $placeholder.html("<span class='screenreader-text'>"+accessIcon.title+"</span>");

                    applyAccessTooltip($placeholder, accessIcon);
                }
            });
        }
    };

    // The wrapper is rendered once per access state by _AccessIconTooltip.cshtml into a
    // <template>, and cloned here. Nothing about its structure is known to this file —
    // the same partial produces the copies that pages render server-side, so the two
    // cannot drift.
    function applyAccessTooltip($placeholder, accessIcon) {
        var $template = $('.js-access-icon-template[data-access-icon="' + accessIcon.icon + '"]').first();

        if ($template.length === 0) {
            return;
        }

        var $wrapper = $($template.prop('content').firstElementChild.cloneNode(true));

        accessTooltipSequence++;
        rewriteTooltipId($wrapper, 'access-tooltip-' + accessTooltipSequence);

        // The alt text is per item, not per state — gift access gives the same icon a
        // different accessible name — so the template's value is only a fallback.
        $wrapper.find('[aria-label]').addBack('[aria-label]').attr('aria-label', accessIcon.title);

        // The placeholder itself is moved into the wrapper rather than replaced by it.
        // It carries whatever the page put on it — OUP's Sigma variant, the multi-path
        // spans ACS re-adds through its MutationObserver — and unwrapAccessTooltip has to
        // be able to pull it back out when an ajax page turn re-runs this.
        $placeholder.removeAttr('title').attr('aria-hidden', 'true').empty();
        $placeholder.after($wrapper);
        $wrapper.find('i').first().replaceWith($placeholder);

        if ($wrapper.hasClass('js-custom-icon-with-disclosure')) {
            bindCustomIconDisclosure($wrapper);
            bindDisclosureDismissHandlers();
            return;
        }

        bindCustomIconTooltip($wrapper);
    }

    // aria-controls and aria-describedby have to resolve to an id that is unique in the
    // document, and every clone starts out carrying the template's.
    function rewriteTooltipId($wrapper, tooltipId) {
        $wrapper.find('.custom-tooltip-content').attr('id', tooltipId);
        $wrapper.find('[aria-controls]').attr('aria-controls', tooltipId);
        $wrapper.filter('[aria-describedby]').attr('aria-describedby', tooltipId);
    }

    // setAccessIcons runs more than once per page — ajax paging concats onto
    // SCM.AccessIcons and re-runs it — so the icon has to come back out of any wrapper
    // it is already in before the access state is re-applied.
    function unwrapAccessTooltip($placeholder) {
        var $wrapper = $placeholder.closest('.js-access-icon-tooltip');

        if ($wrapper.length === 0) {
            return;
        }

        $placeholder.removeAttr('aria-hidden');
        $wrapper.replaceWith($placeholder);
    }

    function removeAllAccessIconClasses($accessIcon) {
        $accessIcon.removeClass(function (index, currentClass) {
            return (currentClass.match(/icon-availability_.+/g) || []).join(' ');
        });
    }

    ns.getAccessIcon = function (resourceId, accessIcons) {
        accessIcons = accessIcons || SCM.AccessIcons;

        var accessIcon;
        accessIcons.map(function (x, y) { if (x.id === resourceId) { accessIcon = x; return false; } });
        return accessIcon;
    };

    ns.initializeCustomIconTooltips = function () {
        $('.js-custom-icon-with-tooltip').each(function() {
            bindCustomIconTooltip($(this));
        });
    };

    function bindCustomIconTooltip($icon) {
        var $tooltip = $icon.find('.custom-tooltip-content');

        if ($tooltip.length === 0 || $icon.data('customIconTooltipBound')) {
            return;
        }

        $icon.data('customIconTooltipBound', true);

        detectEdgePosition($icon, $tooltip);

        $icon.on('mouseenter', function() {
            showTooltip($tooltip);
        });

        $icon.on('mouseleave', function() {
            hideTooltipWithDelay($tooltip, 200);
        });

        $icon.on('focus', function() {
            showTooltip($tooltip);
        });

        $icon.on('focusout', function(e) {
            if (!$icon[0].contains(e.relatedTarget)) {
                hideTooltip($tooltip);
            }
        });

        $tooltip.on('mouseenter', function() {
            clearTooltipHideTimeout($tooltip);
        });

        $tooltip.on('mouseleave', function() {
            hideTooltip($tooltip);
        });
    }

    function showTooltip($tooltip) {
        hideOtherTooltips($tooltip);
        clearTooltipHideTimeout($tooltip);
        detectEdgePosition($tooltip.closest('.js-custom-icon-with-tooltip, .js-custom-icon-with-disclosure'), $tooltip);
        $tooltip.addClass('visible');
    }

    function hideOtherTooltips($tooltip) {
        $('.custom-tooltip-content.visible').not($tooltip).each(function () {
            var $other = $(this);

            var $trigger = $other.siblings('.custom-icon-with-tooltip').first();

            if ($trigger.length === 0) {
                hideTooltip($other);
                return;
            }

            _closeDisclosure($trigger, $other);
        });
    }

    function hideTooltip($tooltip) {
        clearTooltipHideTimeout($tooltip);
        $tooltip.removeClass('visible');
    }

    function hideTooltipWithDelay($tooltip, delay) {
        var timeoutId = setTimeout(function() {
            if (!$tooltip.is(':hover')) {
                $tooltip.removeClass('visible');
            }
        }, delay);

        $tooltip.data('hide-timeout', timeoutId);
    }

    function clearTooltipHideTimeout($tooltip) {
        var timeoutId = $tooltip.data('hide-timeout');
        if (timeoutId) {
            clearTimeout(timeoutId);
            $tooltip.removeData('hide-timeout');
        }
    }

    // The panel is absolutely positioned, so what clips it is the nearest ancestor with
    // overflow other than visible, not the viewport.
    function getClippingBounds($icon) {
        var $ancestors = $icon.parents();

        for (var i = 0; i < $ancestors.length; i++) {
            if (clipsOverflow($ancestors[i])) {
                var rect = $ancestors[i].getBoundingClientRect();
                return {
                    left: rect.left + window.pageXOffset,
                    right: rect.right + window.pageXOffset
                };
            }
        }

        return {
            left: window.pageXOffset,
            right: window.pageXOffset + $(window).width()
        };
    }

    function clipsOverflow(element) {
        var style = window.getComputedStyle(element);
        return NON_VISIBLE_OVERFLOW.test(style.overflowX) || NON_VISIBLE_OVERFLOW.test(style.overflowY);
    }

    function detectEdgePosition($icon, $tooltip) {
        var iconOffset = $icon.offset();

        if (!iconOffset) {
            return;
        }

        var tooltipWidth = $tooltip.outerWidth();
        var iconWidth = $icon.outerWidth();
        var bounds = getClippingBounds($icon);
        var tooltipLeft = iconOffset.left + (iconWidth / 2) - (tooltipWidth / 2);
        var tooltipRight = tooltipLeft + tooltipWidth;

        // Cleared here so a re-run cannot inherit the side the previous layout needed.
        $icon.removeClass('tooltip-left tooltip-right');

        if (tooltipLeft < bounds.left + EDGE_THRESHOLD_PIXELS) {
            $icon.addClass('tooltip-left');
        } else if (tooltipRight > bounds.right - EDGE_THRESHOLD_PIXELS) {
            $icon.addClass('tooltip-right');
        }
    }

    ns.reinitializeTooltips = function () {
        // Scoped to the tooltip-variant JS hook. The disclosure variant reuses
        // both .custom-tooltip-content (its panel) and .custom-icon-with-tooltip
        // (its button trigger), so an un-scoped selector here would delete the
        // disclosure's panel and strip its handlers on every resize, then leave
        // the trigger with aria-expanded pointing at a detached element. See
        // reinitializeCustomIconDisclosures for the disclosure-safe path.
        $('.js-custom-icon-with-tooltip .custom-tooltip-content').remove();
        $('.js-custom-icon-with-tooltip')
            .removeClass('tooltip-left tooltip-right')
            .off('mouseenter mouseleave focus focusout')
            .removeData('customIconTooltipBound');

        ns.initializeCustomIconTooltips();
        ns.reinitializeCustomIconDisclosures();
    };

    // Resize-safe reinit for the disclosure variant: re-run edge detection so
    // the panel stays on-screen after a window resize, but leave the panel and
    // its bound handlers alone. Wiping and rebinding (as the tooltip variant
    // does) would destroy the very link this fix exists to expose.
    ns.reinitializeCustomIconDisclosures = function () {
        $('.js-custom-icon-with-disclosure').each(function () {
            var $wrapper = $(this);
            var $trigger = $wrapper.find('.custom-icon-with-tooltip').first();
            var $panel = $wrapper.find('.custom-tooltip-content').first();
            if ($trigger.length === 0 || $panel.length === 0) {
                return;
            }
            detectEdgePosition($wrapper, $panel);
        });
    };

    function cleanupTooltips() {
        $('.custom-tooltip-content').each(function() {
            var $tooltip = $(this);
            clearTooltipHideTimeout($tooltip);
        });
    }

    // Custom icons whose popup contains interactive content (a link)
    // render as a disclosure widget rather than a tooltip — see CustomIcon.cshtml
    // for the bifurcation. Interactive content inside a role="tooltip" target is
    // an ARIA APG anti-pattern (focus onto the in-popup control announces nothing
    // because AT flattens the description). Disclosure semantics fix that: the
    // button owns the accessible name + aria-expanded state, the panel is a
    // plain container, and the link inside announces normally on focus.
    ns.initializeCustomIconDisclosures = function () {
        $('.js-custom-icon-with-disclosure').each(function () {
            bindCustomIconDisclosure($(this));
        });

        bindDisclosureDismissHandlers();
    };

    function bindCustomIconDisclosure($wrapper) {
        var $trigger = $wrapper.find('.custom-icon-with-tooltip').first();
        var $panel = $wrapper.find('.custom-tooltip-content').first();

        if ($trigger.length === 0 || $panel.length === 0 || $wrapper.data('customIconDisclosureBound')) {
            return;
        }

        $wrapper.data('customIconDisclosureBound', true);

        detectEdgePosition($wrapper, $panel);

        $trigger.on('click', function () {
            var isOpen = $trigger.attr('aria-expanded') === 'true';
            if (isOpen) {
                _closeDisclosure($trigger, $panel);
            } else {
                _openDisclosure($trigger, $panel);
            }
        });

        // Hover is a passive affordance AT never learns about, so it leaves aria-expanded
        // alone (WCAG 1.4.13). A keyboard user is the AT user, so focus opens the disclosure.
        $wrapper.on('mouseenter', function () {
            showTooltip($panel);
        });

        $wrapper.on('mouseleave', function () {
            if ($trigger.attr('aria-expanded') !== 'true') {
                hideTooltipWithDelay($panel, 200);
            }
        });

        $trigger.on('focus', function () {
            if ($trigger.data('suppressFocusOpen')) {
                return;
            }

            // A mouse press focuses the trigger before its own click handler runs, so opening
            // on every focus would make that click read as a second press and close it again.
            if (!isKeyboardFocus($trigger[0])) {
                showTooltip($panel);
                return;
            }

            _openDisclosure($trigger, $panel);
        });

        $wrapper.on('focusout', function (e) {
            if ($wrapper[0].contains(e.relatedTarget)) {
                return;
            }

            _closeDisclosure($trigger, $panel);
        });

        $panel.on('mouseenter', function () {
            clearTooltipHideTimeout($panel);
        });

        $panel.on('mouseleave', function () {
            if ($trigger.attr('aria-expanded') !== 'true') {
                hideTooltip($panel);
            }
        });
    }

    // Registered whether or not a disclosure exists yet: access tooltips are built after
    // page load, so a page can gain its first disclosure long after this runs. Each
    // listener is removed before it is re-added, so calling this repeatedly is safe.
    //
    // Capture phase, because per-client handlers such as the Article Navigation toggle in
    // App.SiteJS.js call e.stopPropagation() and a bubble-phase listener never runs.
    function bindDisclosureDismissHandlers() {
        if (documentKeydownDismissHandler) {
            document.removeEventListener('keydown', documentKeydownDismissHandler, true);
        }

        documentKeydownDismissHandler = function (e) {
            if (e.key !== 'Escape' && e.keyCode !== 27) {
                return;
            }

            $('.js-custom-icon-with-disclosure .custom-icon-with-tooltip[aria-expanded="true"]').each(function () {
                var $trigger = $(this);
                var $panel = $trigger.siblings('.custom-tooltip-content').first();

                _closeDisclosure($trigger, $panel);

                // Refocusing the trigger re-fires its focus handler, which would reopen
                // what Escape just dismissed.
                $trigger.data('suppressFocusOpen', true);
                $trigger.focus();
                $trigger.removeData('suppressFocusOpen');
            });
        };

        document.addEventListener('keydown', documentKeydownDismissHandler, true);

        if (documentClickDismissHandler) {
            document.removeEventListener('click', documentClickDismissHandler, true);
        }

        documentClickDismissHandler = function (e) {
            $('.js-custom-icon-with-disclosure .custom-icon-with-tooltip[aria-expanded="true"]').each(function () {
                var $trigger = $(this);
                var $wrapper = $trigger.closest('.js-custom-icon-with-disclosure');

                // Without this the capture-phase close beats the trigger's own click handler
                // and the disclosure never opens.
                if (!$wrapper[0].contains(e.target)) {
                    var $panel = $trigger.siblings('.custom-tooltip-content').first();
                    _closeDisclosure($trigger, $panel);
                }
            });
        };

        document.addEventListener('click', documentClickDismissHandler, true);
    }

    function isKeyboardFocus(trigger) {
        return supportsFocusVisible && trigger.matches(':focus-visible');
    }

    function _openDisclosure($trigger, $panel) {
        $trigger.attr('aria-expanded', 'true');
        showTooltip($panel);
    }

    function _closeDisclosure($trigger, $panel) {
        $trigger.attr('aria-expanded', 'false');
        hideTooltip($panel);
    }

    $(function() {
        ns.initializeCustomIconTooltips();
        ns.initializeCustomIconDisclosures();
    });

    // reinitializeTooltips strips the panel out of every tooltip-variant icon and rebuilds
    // it from the markup that is already on the page. Access tooltips are cloned from a
    // <template> rather than sitting in the page, so they only come back if setAccessIcons
    // runs again.
    var debouncedReinitialize = debounce(function() {
        ns.reinitializeTooltips();
        ns.setAccessIcons();
    }, 250);

    $(window).on('resize', debouncedReinitialize);

    // Server-rendered icons arrive from an ajax response with their tooltip markup already
    // in place, so nothing binds them the way applyAccessTooltip binds what it clones.
    // Search paging, facets and sorting all replace the results list wholesale, which is
    // where they turn up. Both binders skip anything already bound, so re-running them over
    // the whole page costs a selector scan.
    $(document).ajaxComplete(function () {
        ns.initializeCustomIconTooltips();
        ns.initializeCustomIconDisclosures();
    });

    $(window).on('beforeunload', function() {
        cleanupTooltips();
    });

})(SCM.SiteJS = SCM.SiteJS || {}, jQuery);
